import { useSeatingChart } from './SeatingChart.hooks';
import { Grid, Group, Popover, ScrollArea, Stack, Text, UnstyledButton } from '@mantine/core';
import classes from './SeatingChart.module.css';
import { IconChevronDown, IconLayoutDashboard } from '@tabler/icons-react';
import { CategoryItem } from './SeatingChart.CategoryItem';
import { isMobile } from 'react-device-detect';
import { useMemo, useState } from 'react';
import { useClickOutside } from '@mantine/hooks';

interface CategoryMultiSelectProps {
  categoryModeToggle: (toggle: boolean) => void;
  opened: boolean;
}

export function CategoryMultiSelect({ categoryModeToggle, opened }: CategoryMultiSelectProps) {
  const { selectedMarketplaceEvent: { svgDetails }, form, allSectionsInSeatingChart } = useSeatingChart('selectedMarketplaceEvent', 'form', 'allSectionsInSeatingChart');
  const [toggleButton, setToggleButton] = useState<HTMLElement | null>(null);
  const [popoverMenu, setPopoverMenu] = useState<HTMLElement | null>(null);
  const svgSeatingChart = Array.from(document.querySelectorAll('#seatingChartSVG svg *')) as HTMLElement[];
  useClickOutside(() => { categoryModeToggle(false); }, null, [toggleButton, popoverMenu, ...svgSeatingChart]);

  const categoriesSelectedCount = useMemo(() => {
    if (!svgDetails?.categories || !form.values.sectionIds) return 0;

    const categoryNames = new Set(
      svgDetails.categories.map((c) => c.name.toLowerCase())
    );

    return form.values.sectionIds.reduce(
      (count, id) => (categoryNames.has(id.toLowerCase()) ? count + 1 : count),
      0
    );
  }, [svgDetails?.categories, form.values.sectionIds]);

  const categories = (svgDetails?.categories || []).filter(c => allSectionsInSeatingChart.some(s => s.toLowerCase() === c.sectionId.toLowerCase().replaceAll('-', ' ') || s.toLowerCase() === c.sectionId.toLowerCase().replaceAll('-', ' ')));
  return (
    <Popover position="bottom" opened={opened} width={isMobile ? 185 : 237} offset={-1} shadow="XS" id={classes.categoryMultiselect}>
      <Popover.Target>
        <UnstyledButton ref={setToggleButton} onClick={() => categoryModeToggle(!opened)} className={classes.categoryMultiselectButton}>
          <Grid h="100%" w="100%" gap={5} align="center">
            <Grid.Col w={isMobile ? 155 : 201} span="content" h="100%">
              <Group justify="start" py={7} pl={isMobile ? 6 : 12} pr={isMobile ? 0 : 5} h="100%" wrap="nowrap">
                  <IconLayoutDashboard size={18} />
                {isMobile ? <Text>Categories • {categoriesSelectedCount}/{categories.length}</Text> :
                  <Text>
                    Categories • {categoriesSelectedCount} selected
                  </Text>
                }
              </Group>
            </Grid.Col>
            <Grid.Col
              span="content"
              h="100%"
              className={classes.categoryDropdownIcon}
            >
              <IconChevronDown size={18} />
            </Grid.Col>
          </Grid>
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown p="sm" className={classes.categoryDropdown}>
        <ScrollArea.Autosize ref={setPopoverMenu} mah={300} type="never">
          <Stack style={{ justifyContent: 'space-between' }}>
            {categories.map((category) => (<CategoryItem category={category} key={category.name} />))}
          </Stack>
        </ScrollArea.Autosize>
      </Popover.Dropdown>
    </Popover>);
}
